module.exports = {
  userAccount: '登录手机号',
  changeCaptcha: '点击图片更换验证码',
  password: '登录密码',
  login: '登录',
  contactCustomer: '联系客服',
  help: '帮助',
  tips: '登录即表示您同意协议',
  agreement: '协议',
  accountNumber: '记住登录手机号',
  captcha: '验证码',
  success: '登录成功！',
  noUserInfo: '获取用户信息失败!',
  noIndex: '获取密钥失败!',
  policy: {
    title: '用户协议',
    preface: '本协议是“ WOWNOW用户服务协议”的修订版。 自本协议签署之日起，“ WOWNOW用户服务协议”在整个WOWNOW网站中广为人知。 指此协议。 [仔细阅读]在申请注册过程中，单击并同意本协议之前，应仔细阅读本协议。 请务必仔细阅读并充分理解其条款和条件，尤其是免责或责任限制，法律适用和争端解决条款的条款。 免责或责任限制条款将以粗体下划线标出，您应重点阅读。',
    overviewTitle: '一，概述',
    overviewText: '第一条本服务协议的各方为U-LIFE KH SUPER APP Co.，Ltd及其网站“ WOWNOW和WOWNOW网站用户”，此服务协议具有合同效力。\n' +
        '第二条本服务协议的内容包括协议文本以及WOWNOW已发布或将来可能发布的所有规则。所有规则都是协议的组成部分，与协议的主体具有相同的法律效力。\n' +
        '第三条用户在使用WOWNOW提供的服务时，承诺接受并遵守相关规则。 WOWNOW有权根据需要不时制定和修改本协议或各种规则。如果本协议有任何更改，WOWNOW将在WOWNOW应用程序上发布公告。如果用户不同意相关更改，则必须停止使用服务。修订后的协议在WOWNOW应用程序上发布后将自动生效。各种规则发布后将生效，并成为本协议的一部分。登录或继续使用服务将表明用户接受修订后的协议。除非另有明确说明，否则任何扩展或扩大服务范围的新内容均受本协议约束。\n',
    definitionTitle: '二，定义',
    definitionText: '第四条WOWNOW的用户：用户是具有完全民事行为能力的自然人。如果没有民事行为能力的人或具有有限民事行为能力的人被错误地注册为WOWNOW用户，或从事超出其公民权利或能力的交易，则与WOWNOW的服务协议应无效，一旦发现，WOWNOW具有立即取消用户的权利，并承担使用WOWNOW“服务”的所有法律责任。\n' +
        '第五条用户注册是指用户登录到WOWNOW网站并按要求填写相关信息并确认协议后执行相关用户协议的过程。用户负责交易引起的所有应税转让，订单的付费服务或与EA / WOWNOW网站服务器的联系，以及所有硬件，软件，服务和其他费用。 WOWNOW网站仅用作订购餐点的交易平台。\n' +
        '第六条：WOWNOW规则：为了感谢WOWNOW用户的支持并创建一个健康，时尚和有序的在线订购平台，WOWNOW网站启动了积分。该系统为订购用户实现消费积分反馈，促销积分礼品和积分兑换礼品。 WOWNOW规则是基于此的一套完整的积分奖励和交换系统。\n' +
        '第七条WOWNOW礼物：WOWNOW发行的积分兑换礼物，主要用于实物礼物和现金。提交礼品兑换申请后，通过WOWNOW确认并发出礼品后，卡WOWNOW保证普通礼品和电子礼品的质量均为真品，礼品不再提供退货服务。请与制造商联系以获得后续保修服务。\n' +
        '第八条：WOWNOW在线订购系统：由WOWNOW开发，它为用户提供了用于在网站上进行交易的平台软件。用户可以使用该系统进行订单和积分管理，而商家可以使用它。该系统执行商店和外卖信息的发布和订单管理。\n',
    obligationsTitle: '三，用户的权利和义务',
    obligationsText: '第九条为了为广大用户创建健康有序的网络服务交易平台，WOWNOW采取严格的审计和与商家的紧密合作，以最大程度地减少用户的虚假订单，减少饭店损失。 WOWNOW提倡完整性交易，并为此提供了一系列解决方案。\n' +
        'WOWNOW为用户提供了一个交易平台。 WOWNOW只能部分控制交易中涉及的产品的质量，安全性或合法性，业务信息的真实性或准确性以及交易方的表现。履行贸易协定义务的能力。考虑到WOWNOW平台在海量信息和信息网络环境下具有信息和物理隔离的特点，因此WOWNOW平台不能一一查看商品和/或服务信息，也无法一一检查交易。一。您应谨慎对待所涉及商品和/或服务的质量，安全性，合法性，真实性和准确性。\n' +
        '第十条普通用户的权利：\n' +
        '（1）用户有权在WOWNOW网站上拥有自己的用户名和密码，并有权随时使用自己的用户名和密码登录WOWNOW在线订购平台。用户不得以任何形式转让或授权他人使用其自己的WOWNOW网站用户名；\n' +
        '（2）用户有权通过订购和促销WOWNOW网站获得消费积分和促销积分，并使用这些积分兑换礼品；\n' +
        '（3）用户有权使用WOWNOW在线订购系统，并且WOWNOW商家在线获得直接联系，以获得最新的食品信息和相关的增值服务；用户单击“开始结算”按钮。系统将自动生成包含产品名称，购买数量，到期总金额和交货地址（如果有）的订单，用户应仔细检查。用户单击订单底部的“付款”按钮，用户已经阅读并同意了外卖页面的所有内容，并批准了订单内容。订单内容和外卖页面信息被视为用户与商家和送货服务提供商之间的外卖交易合同。\n' +
        '（4）在商家确认用户的订单之后，商家或第三方送货服务提供商将完成送货服务。用户同意并知道商户向您提供了一些商品，在这种情况下，有关送货服务的标准是根据商户在WOWNOW在线订购平台上发布的标准（包括但不限于费用）实施的。同时，某些产品将由第三方交付服务提供商交付给您。提供送货服务的一方将向您收取一定的送货服务费。下订单时将显示特定金额。金额取决于金额，您知道并授权第三方送货服务提供商代表您提货，然后将货物交付到您指定的收货地址。用户支付的交付费用将由WOWNOW收取，并支付给实际的交付服务提供商。用户有权在实际支付的金额范围内索要餐费发票。膳食的金额由商人提供，交付费用的金额由交付服务提供商提供。\n' +
        '（5）用户有权对WOWNOW商家的服务进行评估和投诉，并提出建议和意见；\n' +
        '（6）如果用户在WOWNOW交易的交易过程中与商家有争议，则他/她可以请求WOWNOW的协调。对于商户或第三方配送团队在整个物流配送过程中造成的损坏，损害，损失等，责任方将承担赔偿责任。 WOWNOW将根据平台规则积极与用户合作。这部分损失得以弥补。如果用户发现其他用户非法或违反了服务协议，则可以将请求报告给WOWNOW。如果用户已与其他用户对交易提起诉讼，则该用户有权通过司法部门要求提供相关信息，以请求获得WOWNOW。\n' +
        '第十一条普通用户的义务：\n' +
        '（1）用户有义务在注册时提供自己的真实信息，并确保诸如电子邮件地址，联系电话，联系地址，邮政编码等内容的有效性和安全性。确保WOWNOW和其他用户可以通过上述联系方式联系自己。同时，当相关信息实际改变时，用户还必须及时更新相关注册信息。不保证用户可以使用其他人的信息在WOWNOW网站上进行注册或认证。如果用户使用虚假电话号码，姓名，地址或欺诈性使用他人信息来使用WOWNOW订购服务，则WOWNOW将作出相应的处罚或封锁地址处理；\n' +
        '（2）用户不得在WOWNOW在线订购平台上恶意评估其他商户，或采取不公平的措施提高其信誉度或降低其他商户的信用度；\n' +
        '（3）WOWNOW用户承诺使用WOWNOW网站时不会出现以下违规行为。例如，由于以下违规行为引起的任何法律后果，WOWNOW用户将以自己的名义承担所有法律责任：\n' +
        '1.违反国家法律，法规和各种社会公共利益或公共道德的行为；\n' +
        '2.违反WOWNOW的规定（包括但不限于虚假订单的制造，利用系统漏洞获取利润，非法兑现等）；\n' +
        '3.损害WOWNOW平台，商家和其他用户利益的其他行为。\n' +
        '（iv）WOWNOW用户同意不得将WOWNOW网站上的信息用于任何商业用途，包括但不限于WOWNOW的事先书面批准。任何通过复制，散布的方式使用WOWNOW网站上显示的任何材料等；\n' +
        '（5）WOWNOW用户同意接收来自WOWNOW网站或WOWNOW网站合作伙伴的电子邮件和消息。\n' +
        '（6）WOWNOW用户同意授权或允许第三方使用个人信息（包括但不限于身份）进行WOWNOW平台产生的交易。信息，账户信息，交易信息等\n' +
        '第十二条：WOWNOW的权利\n' +
        '（1）对于用户在WOWNOW在线订购平台上的不当行为或应终止服务的任何其他WOWNOW，WOWNOW有权随时删除。未经用户同意，处理相关信息，终止服务等。\n' +
        '（2）如果用户在WOWNOW在线订购平台的交易过程中与其他用户有争议，则请求将从WOWNOW转移，在WOWNOW审核后，WOWNOW有权通过电话或电子邮件通知各方，并通过电话或电子邮件互相通知。\n' +
        '（3）WOWNOW有权检查用户的注册信息和交易行为，发现注册信息或交易行为中的任何问题或疑问，并有权向用户发送通知并要求更正或直接进行更改。删除和其他处理；\n' +
        '（4）确认用户已通过国家法律文书或行政处罚决定违反了法律，或者WOWNOW有充分的事实依据可确定用户违反了法律或违反了服务协议，并且WOWNOW有权在WOWNOW交易平台及其所在的网站上以网络发布的形式发布用户的非法行为；\n' +
        '（5）对于用户在WOWNOW在线订购平台上发布的各种违规信息，WOWNOW有权在不通知用户的情况下删除或采取其他限制性措施，包括但不限于：\n' +
        '1.以规避费用为目的的信息；\n' +
        '2.用于推测信用的信息；\n' +
        '3.存在有关恶意或虚假内容（例如欺诈）的信息；\n' +
        '4.与在线订购交易无关或不用于订购的信息；\n' +
        '5.有恶意或其他信息试图破坏正常订单交易的顺序；\n' +
        '6.违反公共利益或可能严重损害WOWNOW和其他用户的合法利益的信息。\n' +
        '（6）许可权。用户向WOWNOW授予专有，通用，永久和免费的许可权（并有权重新授权），从而使WOWNOW权利（全部或部分）可以使用，复制，修改，重写，发布，翻译，分发，执行并显示用户在网站上发布的各种类型的信息或制作其衍生作品，和/或以现在已知或以后开发的任何形式，媒体或技术将上述信息整合到其他作品中；\n' +
        '（7）WOWNOW将在用户计算机上设置或访问WOWNOW Cookies。 WOWNOW允许在WOWNOW网站上发布广告的公司设置或访问用户计算机上的cookie。当用户登录获取信息时，WOWNOW使用cookie为用户提供个性化服务。如果所有cookie均被拒绝，则用户将无法使用需要登录的WOWNOW产品和服务。\n' +
        '第13条：WOWNOW的义务：\n' +
        '（1）WOWNOW有义务在现有技术下保持整个交易平台的正常运行，并努力改进和改进该技术，以便用户的在线订购交易能够顺利进行。\n' +
        '（2）在注册使用WOWNOW在线订购平台的过程中，WOWNOW应及时响应与用户遇到的交易或注册相关的问题和思考。\n' +
        '（3）如果用户在WOWNOW在线订购交易中与其他用户提起诉讼，则用户按照法律程序通过司法部门或行政部门要求提供相关信息，并且卡为WOWNOW。应积极配合并提供相关信息。\n',
    InterruptTitle: '四，服务的中断和终止',
    InterruptText: '第十四条用户同意，在WOWNOW不向用户收取服务费的情况下，WOWNOW可以自行决定以任何理由做出决定（包括但不限于WOWNOW认为用户违反了文字本协议的含义和精神，或以与本协议的字面含义和精神不符的方式行事，或者用户超过90天未使用其帐户和密码登录网站等。 ）“服务”密码，帐户（或其任何部分）或用户对服务的使用，并删除（不再保存）用户在服务中提交的任何资料。同时，WOWNOW可以自行决定随时在不通知或不通知的情况下停止提供服务或其任何部分。帐户终止后，WOWNOW没有义务保留原始帐户中或与之相关的任何信息，也没有义务将尚未读取或发送给用户或第三方的任何信息转发。此外，WOWNOW用户同意，WOWNOW对于终止用户对服务的访问对用户或任何第三方概不负责。\n' +
        '第十五条用户向WOWNOW提交WOWNOW的注册用户的身份时，应当予以注销，并由WOWNOW批准。注册用户后，用户与WOWNOW解除了服务协议关系。但是，取消用户帐户后，WOWNOW仍然保留以下权利：\n' +
        '（1）用户注销后，WOWNOW有权保留用户的注册信息和以前的交易记录记录；\n' +
        '（2）用户注销后，如果在注销之前用户违反了法律或违反了WOWNOW在线订购平台上的合同，则WOWNOW仍然可以行使服务协议中规定的权利。 。\n' +
        '第十六条在下列情况下，WOWNOW可以通过取消用户来终止服务：\n' +
        '（1）当用户违反本服务协议的相关条款时，WOWNOW有权直接向用户终止服务。但是，如果用户在被WOWNOW终止后直接或间接或以他人的名义注册为WOWNOW用户，则WOWNOW有权重新选择终止向用户提供服务；\n' +
        '（2）如果WOWNOW通过用户提供的信息联系用户，则发现用户在注册时填写的电子邮件地址不再存在或无法接收电子邮件，并且该卡对其他用户为WOWNOW联系人信息会将更改通知用户，并且用户仍无法在三个工作日内提供新的电子邮件地址。 WOWNOW有权向用户终止服务；\n' +
        '（3）一旦WOWNOW发现用户注册数据的主要内容为假，WOWNOW有权随时终止对用户的服务；\n' +
        '（4）服务协议终止或更新时，用户明确拒绝接受新的服务协议；\n' +
        '（5）其他WOWNOW认为该服务需要终止。\n' +
        '第十七条WOWNOW用户因违反法律法规或违反服务协议而被中断或终止的，其交易行为应按以下原则处理：\n' +
        '（1）在服务中断或终止之前，如果用户已上载到WOWNOW网站的产品尚未交易或尚未完成，则WOWNOW有权在与服务同时删除该项目被中断或终止。有关该物品的信息；\n' +
        '（2）在服务中断或终止之前，用户已经对其他用户出售的特定产品提出了要约，但交易尚未完成，WOWNOW有权在中断时删除用户的相关要约或终止服务；\n' +
        '（3）在服务中断或终止之前，用户已与另一用户就特定交易达成协议。 WOWNOW可能不会删除事务，但是WOWNOW有权中断或终止服务。同时，将服务的中断或终止通知给用户的对方。\n' +
        '第18条：WOWNOW有权单方面出现在WOWNOW在线订购平台上，包括但不限于损害WOWNOW利益，例如刷卡/虚假订单。终止服务的提供，并要求用户加倍通过刷卡/虚假订单获得的不当利益，例如对WOWNOW实际损失的赔偿不足，WOWNOW有权进一步追回并保留提起诉讼的权利。\n',
    responsibilityTitle: '五，责任范围',
    responsibilityText: '第19条用户明确理解并同意，WOWNOW对以下任何情况引起的任何损害不承担责任，包括但不限于利润损失，商誉，使用，数据等。其他无形损失（无论是否已通知WOWNOW有关此类损害的可能性）：\n' +
        '（一）使用或者不使用“服务”的；\n' +
        '（2）第三方的未授权访问或第三方更改用户的传输数据或数据；\n' +
        '（3）第三方关于“服务”或“服务”的声明；\n' +
        '（4）或单方面/ WOWNOW引起的与“服务”相关的任何其他事项，包括过失。\n' +
        '第二十条用户明确理解并同意，如果违反相关法律或本协议的规定，WOWNOW遭受任何损失，受到任何第三方的索赔或受到任何行政部门的惩罚，应向用户提供WOWNOW的赔偿。 ，包括合理的律师费。',
    foodSafetyTitle: '食品安全保证',
    foodSafetyText: '第二十一条用户通过WOWNOW订购的食品存在食品安全问题或质量不合格的，可能会损害自身的健康和权益，造成食品中毒或其他不利后果，用户有权提起投诉。商家应对此负责，在发现事实是真实的之后，WOWNOW可以追偿用户造成的损失和相应的经济补偿。\n' +
         '第二十二条用户发出投诉信息时，WOWNOW将审查用户提供的信息，并有权要求用户提供相应的证据，以证明信息的真实性和合法性，而该信息是无法提供的。用户。在有效证据的情况下，WOWNOW有权删除相关信息或终止赔偿，并且用户可以与商家沟通以追究责任。\n' +
         '隐私政策\n' +
         '第二十三条适用范围：\n' +
         '（1）用户注册WOWNOW帐户时，根据WOWNOW的要求，由用户提供的个人注册信息；\n' +
         '（2）当用户使用WOWNOW服务，参与WOWNOW活动或访问WOWNOW网站页面时，WOWNOW会自动在用户浏览器中接收并记录服务器值，包括但不限于IP地址和其他信息以及用户请求的网站页面记录；\n' +
         '（3）WOWNOW收集的有关WOWNOW在线订购交易的相关材料，包括但不限于招标，购买，产品注册，信用评估和违规记录；\n' +
         '（4）WOWNOW获得的用户个人数据可以通过合法途径向业务合作伙伴索取。\n' +
         '第24条：信息的使用：\n' +
         '（1）为了服务用户，WOWNOW可以通过使用用户的个人信息为用户提供服务，包括但不限于向用户发布产品和服务信息，或与WOWNOW合作伙伴共享信息，以便他们向用户发送有关其产品的信息和服务。\n' +
         '第二十五条信息披露\n' +
         '在以下情况下，部分或全部披露用户的个人信息：\n' +
         '（1）经用户同意向第三方披露；\n' +
         '（2）如果用户是合格的知识产权投诉人并提出了投诉，则应投诉人的要求将其披露给被诉人，以便双方可以处理可能的权利纠纷；\n' +
         '（三）依照法律的有关规定或者行政或者司法机关的要求向第三方或者行政或者司法机关公开；\n' +
         '（4）用户违反中国有关法律或网站政策的，需要向第三方披露；\n' +
         '（5）为了提供您要求的产品和服务；您必须与第三方共享用户的个人信息；\n' +
         '（6）披露其他WOWNOW根据法律或网站政策认为适当的信息；\n' +
         '（7）在WOWNOW网站上创建的在线订购交易中，如果交易的任何一方履行或部分履行了在线订购交易义务并要求信息披露，则WOWNOW完全有可能决定向用户提供必要的信息，例如交易对手的联系信息，以帮助完成在线订购交易或解决纠纷。\n' +
         '第二十六条信息安全\n' +
         '（1）WOWNOW帐户具有密码保护功能。请正确保留用户的帐户和密码信息；\n' +
         '（2）在使用WOWNOW服务进行交易时，不可避免地要求用户向在线订购交易对手或潜在的在线订购交易对手提供他们的个人信息，例如联系信息或邮政地址。要求用户保护其个人信息，并仅在必要时提供给他人；\n' +
         '（3）如果用户发现其个人信息被泄露，特别是如果WOWNOW帐户或密码被泄露，请立即联系WOWNOW客户服务，以使WOWNOW采取相应的措施。\n' +
         '第二十七条Cookies的使用\n' +
         '（1）本政策适用于通过WOWNOW设置的cookie获得的相关信息；\n' +
         '（2）在WOWNOW上做广告的公司将通过广告使用在用户计算机上设置的cookie，并将根据其自己的隐私权政策使用它。\n' +
         '第28条：编辑和删除个人信息的权利：除非WOWNOW另行指定，否则用户可以单击我的WOWNOW编辑和删除用户的个人信息。\n',
    supplementTitle: '六，补充',
    supplementText: '第二十九条本协议不涉及WOWNOW用户与其他用户之间由于网站交易产生的法律关系和法律纠纷。' +
        '第30条WOWNOW保留对本协议进行不定期修改的权利。以已发布协议的内容为准。' +
        '通过填写信息，阅读并同意本协议并完成注册页面上指示的所有注册程序，您已经阅读，理解并接受了本协议的全部内容，并同意使用WOWNOW成为WOWNOW平台“用户”。在阅读本协议的过程中，如果您不同意本协议或其任何条款，则应立即停止注册过程。'
  },
  logout: '退出登录',
  loginPhoneValidFail: '请输入手机号',
  loginPasswordValidFail: '请输入密码',
  loginCaptchaValidFail: '请输入验证码',
  getMerchantError: '获取门店信息异常',
  sendValid: '发送验证码',
  sendAfter: '{arg1}s后重新获取',
  forgetPassword: '忘记密码',
  confirmPassword: '确认密码'
}
